import React from 'react'
import Icons from '../Icons'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {Layer} from 'grommet/components/Layer'
import Button from '../Button/Button'
import MediaQuery from 'react-responsive'
import {_L, useLocaleState} from '../../context/LocaleContext'

const Container = styled.div`
  width: 588px;
  height: 388px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 630px) {
    width: 310px;
    border-radius: 0;
  }
`

const TextContainer = styled.div`
  margin-top: 60px;
  text-align: center;
  width: 300px;
  padding: 0 30px 0 30px;
`

const Title = styled.div`
  padding-top: 26px;
  font-size: 25px;
  font-weight: 600;
  letter-spacing: -0.4px;
  line-height: 30px;
  color: white;

  @media (max-width: 630px) {
    font-size: 18px;
    line-height: 22px;
  }
`
const SubTitle = styled.div`
  color: #a4a9b7;
  margin-top: 20px;
  font-size: 14px;
  font-weight: 600;

  @media (max-width: 630px) {
    font-size: 12px;
  }
`

const StyledLayer = styled(Layer)`
  background-color: #282d41;
  border-radius: 6px;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.6);

  @media (max-width: 630px) {
    border-radius: 4px;
  }
  

`

const StyledButton = styled(Button)`
  width: 100%;
  height: 72px;
  border-radius: 0;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1.1px;
  text-align: center;

  @media (max-width: 630px) {
    height: 50px;
    font-size: 16px;
  }
  
  :focus{
  	box-shadow: none;
  	outline: 5px solid #FF9900;
  }
`
const Confirmation = ({title, subTitle, goToMain}) => {
  const localeState = useLocaleState()
  
  return (
    <MediaQuery maxWidth={420}>
      {matches => (
        <StyledLayer margin={matches ? 'none' : 'large'} responsive={false}>
          <Container role="alertdialog" aria-modal="true" aria-describedby="dialog_title">
            <TextContainer>
              <Icons icon="SUCCESS" />
              <Title id="dialog_title">{title}</Title>
              <SubTitle>{subTitle}</SubTitle>
            </TextContainer>
            <StyledButton
              autoFocus
              
              id="confirm_btn"
              onClick={goToMain}
              onKeyDown={goToMain}
              label={_L({key: 'GO TO MAIN', localeState})}
            />
          </Container>
        </StyledLayer>
      )}
    </MediaQuery>
  )
}

Confirmation.propTypes = {
  title: PropTypes.string.isRequired
}

export default Confirmation
